<lib-form-field-container
    [isOptional]="false"
    [kind]="FormContainerKind.SubForm"
    [hideErrors]="true">
    <ng-content
        supportingText
        select="[supportingText]"></ng-content>
    <form [formGroup]="form">
  
            <lib-input-select
                qaTag="$$Library_BillingProfile_InputSelect_Category"
                [formControl]="form.controls.EventCategory"
                [layout]="FormFieldLayout.Half"
                (change)="Changed()">
                <ng-container
                    label
                    i18n="@@CommonCategory">
                    Category
                </ng-container>
                @for (category of categories; track category.ID) {
                    <lib-input-select-item [qaTag]="'$$Library_BillingProfile_InputSelect_Category_Option_' + category.ID" [value]="category">
                        {{ category.Name }}
                    </lib-input-select-item>
                }
            </lib-input-select>
            <lib-input-number
                qaTag="billing-profile-default-duration-input"
                [formControl]="form.controls.DefaultLessonLength"
                [layout]="FormFieldLayout.Half"
                [errorMessages]="defaultLessonLengthErrorMessages"
                (change)="AdjustMakeupCredits()">
                <ng-container
                    label
                    i18n="@@CommonDuration">
                    Duration
                </ng-container>
                <ng-container
                    suffixText
                    i18n="@@CommonMinutesLowercase">
                    minutes
                </ng-container>
            </lib-input-number>
        <ng-content select="[additionalContent]"></ng-content>
            <lib-radio-group
                [formControl]="form.controls.DefaultBillingMode"
                (change)="Changed(); BillingModeChanged($event)">
                <ng-container label>
                    @if (packagesMode) {
                        <ng-container i18n="@@CommonLessonPriceFallBack">#Lesson# Price (Fallback)</ng-container>
                    } @else {
                        <ng-container i18n="@@CommonLessonPrice">#Lesson# Price</ng-container>
                    }
                </ng-container>
                <ng-container supportingText>
                    @if (packagesMode) {
                        <small i18n="@@CommonLessonPriceFallbackSupportingText">Only used when the #student# has no remaining package time.</small>
                    }
                </ng-container>
                <lib-radio-group-item
                    [value]="BillingProfileDefaultMode.PerLesson"
                    qaTag="per-lesson">
                    <ng-container i18n="@@CommonBillingProfilePerLesson">Per #lesson#</ng-container>
                    <ng-container radioSupportingText i18n="@@CommonBillingProfilePerLessonSupportingText">Same price regardless of #lesson# duration</ng-container>
                </lib-radio-group-item>
                @if (!packagesMode) {
                    <lib-radio-group-item
                        [value]="BillingProfileDefaultMode.FixedMonthly"
                        qaTag="per-month">
                        <ng-container i18n="@@CommonBillingProfileFixedMonthly">Fixed monthly</ng-container>
                        <ng-container radioSupportingText i18n="@@CommonBillingProfileFixedMonthlySupportingText">A fixed fee applied to any month containing a billable event</ng-container>
                    </lib-radio-group-item>
                }
                <lib-radio-group-item
                    [value]="BillingProfileDefaultMode.Hourly"
                    qaTag="per-hour">
                    <ng-container i18n="@@CommonBillingProfileHourly">Hourly</ng-container> 
                    <ng-container radioSupportingText i18n="@@CommonBillingProfileHourlySupportingText">Charges will automatically adjust to #lesson# duration</ng-container>
                </lib-radio-group-item>
               @if (!packagesMode) {
                    <lib-radio-group-item
                        [value]="BillingProfileDefaultMode.None"
                        qaTag="none">
                        <ng-container i18n="@@CommonBillingProfileNoCharges">No charges</ng-container>
                        <ng-container radioSupportingText i18n="@@CommonBillingProfileNoChargesSupportingText">Don't create calendar-generated charges or don't use package time</ng-container>
                    </lib-radio-group-item>
                }
            </lib-radio-group>
        @if(!isNone) {

                @if(isPerLesson){
                    <lib-input-currency
                        [formControl]="form.controls.LessonPrice"
                        [layout]="FormFieldLayout.Half"
                        [errorMessages]="lessonPricePerLessonErrorMessages"
                        qaTag="enter-price-per-lesson"
                        (change)="Changed()">
                        <ng-container
                            label
                            i18n="@@CommonRate">
                            Rate
                        </ng-container>
                        <ng-container
                            suffixText
                            i18n="@@CommonLessonRatePerLessonSuffixLowercase">
                            per #lesson#
                        </ng-container>
                    </lib-input-currency>
                } @else if (isHourly) {
                    <lib-input-currency
                        [formControl]="form.controls.LessonPrice"
                        [layout]="FormFieldLayout.Half"
                        [errorMessages]="lessonPriceHourlyErrorMessages"
                        qaTag="enter-price-per-hour"
                        (change)="Changed()">
                        <ng-container
                            label
                            i18n="@@CommonRate">
                            Rate
                        </ng-container>
                        <ng-container
                            suffixText
                            i18n="@@CommonHourlyRateSuffixLowercase">
                            per hour
                        </ng-container>
                    </lib-input-currency>
                } @else if(isPerMonth) {
                    <lib-input-currency
                        [formControl]="form.controls.LessonPrice"
                        [layout]="FormFieldLayout.Half"
                        [errorMessages]="lessonPriceMonthlyErrorMessages"
                        qaTag="enter-price-per-month"
                        (change)="Changed()">
                        <ng-container
                            label
                            i18n="@@CommonRate">
                            Rate
                        </ng-container>
                        <ng-container
                            suffixText
                            i18n="@@CommonMonthlyRateSuffixLowercase">
                            per month
                        </ng-container>
                    </lib-input-currency>
                }
        }
        @if(showCredits) {
                <lib-input-decimal
                    [formControl]="form.controls.Credits"
                    [errorMessages]="creditsErrorMessages"
                    [minDecimalPlaces]="0"
                    qaTag="enter-make-up-credits"
                    [ngClass]="{ 'pb-1': showBanner }"
                    [debounceTime]="200"
                    (realTimeValueChanged)="UpdateBannerState($event)"
                    [allowNegativeInput]="true"
                    (change)="AdjustMakeupCredits(true)">
                    <ng-container
                        label
                        i18n="@@TeacherPortalStudentsSetMakeUpCreditsToLabel">
                        Set Make-Up Credits
                    </ng-container>
                    <ng-container
                        suffixText
                        i18n="@@LibraryMakeUpCreditsSuffixLowercase">
                        credits
                    </ng-container>
                </lib-input-decimal>
        }
        @if (showBanner) {
                <lib-banner
                    [kind]="StatusKind.Warning"
                    [isDismissable]="false">
                    <ng-container
                        text
                        i18n="@@LibraryManualMakeUpCreditsDescription">
                        Manually added make-up credits aren't tied to events on the calendar yet and will expire at midnight. Make sure to book them in a Make-Up
                        Required event before they expire!
                    </ng-container>
                </lib-banner>
        }
    </form>
</lib-form-field-container>